module.exports = __webpack_public_path__ + "static/media/ckn_reporte_exportar.7daf549a.jpg";